var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('ResHubLogo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }